import { render, staticRenderFns } from "./BiddingRequestRow.vue?vue&type=template&id=f4a95e7c"
import script from "./BiddingRequestRow.vue?vue&type=script&lang=js"
export * from "./BiddingRequestRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports